import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import MaterializedApprovalFlow from 'modules/approvals/store/models/MaterializedApprovalFlow'

export class MaterializedApprovalFlows extends Collection<MaterializedApprovalFlow> {
  get cacheKey(): string {
    return 'materializedApprovalFlows'
  }

  model() {
    return MaterializedApprovalFlow
  }
}

const { provider: MaterializedApprovalFlowProvider, hook: useMaterializedApprovalFlows } =
  createCollectionContext<MaterializedApprovalFlow, MaterializedApprovalFlows>()
